module.exports = __webpack_public_path__ + "fonts/KI39dMJZ.woff2";